import type { RecommendedPlayGameType } from "./pickRecommendedPlayGame";

const INTRO_SEEN_PREFIX = "c8_game_intro_seen_v1:";
const PLAYED_PREFIX = "c8_game_played_v1:";
const FIRST_VISIT_TOUR_AT_KEY = "c8_first_visit_tour_at_v1";
/** Skip per-game lobby intro briefly after the global first-visit tour. */
const INTRO_DEFER_AFTER_TOUR_MS = 24 * 60 * 60 * 1000;

function introKey(gameType: RecommendedPlayGameType): string {
    return `${INTRO_SEEN_PREFIX}${gameType}`;
}

function playedKey(gameType: RecommendedPlayGameType): string {
    return `${PLAYED_PREFIX}${gameType}`;
}

export function hasSeenGameIntro(gameType: RecommendedPlayGameType): boolean {
    try {
        return localStorage.getItem(introKey(gameType)) === "1";
    } catch {
        return false;
    }
}

export function markGameIntroSeen(gameType: RecommendedPlayGameType): void {
    try {
        localStorage.setItem(introKey(gameType), "1");
    } catch {
        /* ignore */
    }
}

export function markGamePlayed(gameType: RecommendedPlayGameType): void {
    try {
        localStorage.setItem(playedKey(gameType), "1");
        localStorage.setItem(introKey(gameType), "1");
    } catch {
        /* ignore */
    }
}

export function hasLocalGamePlayRecord(gameType: RecommendedPlayGameType): boolean {
    try {
        return localStorage.getItem(playedKey(gameType)) === "1";
    } catch {
        return false;
    }
}

/** Called when the global first-visit tour is dismissed or played. */
export function noteFirstVisitPlayTourCompleted(): void {
    try {
        localStorage.setItem(FIRST_VISIT_TOUR_AT_KEY, String(Date.now()));
    } catch {
        /* ignore */
    }
}

/** True when the first-visit tour finished this recently (same visit / short session). */
export function wasFirstVisitPlayTourCompletedWithin(ms: number): boolean {
    try {
        const raw = localStorage.getItem(FIRST_VISIT_TOUR_AT_KEY);
        if (!raw) return false;
        const at = Number(raw);
        if (!Number.isFinite(at)) return false;
        return Date.now() - at < ms;
    } catch {
        return false;
    }
}

export function shouldDeferGameIntroAfterFirstVisitTour(): boolean {
    return wasFirstVisitPlayTourCompletedWithin(INTRO_DEFER_AFTER_TOUR_MS);
}
